module.exports = __webpack_public_path__ + "img/new_coupon_banner_jp@2x.71886c61.png";